
import React, { useState, useEffect } from "react";
import "@ant-design/compatible/assets/index.css";
import {
  Button,
  Row,
  Col,
  Table,
  Spin,
  Select,
  Form,
  Input,
  DatePicker,
  Pagination,
  Tag
} from "antd";
import { convertColumns } from "../../../../utils/columnconverter";
import {
  ClearOutlined,
  SearchOutlined,
  ContainerOutlined,
  CalendarOutlined
} from "@ant-design/icons";

import { notify } from "../../../../redux/actions";
import { connect } from "react-redux";
import aictia from "../../../../const/api";
import moment from "moment";
import { useTranslation } from "react-i18next";
const { Option } = Select;
const { RangePicker } = DatePicker;
function Logs() {
  let mainUrl = "ReyestrOfCompany";
  const [form] = Form.useForm();
  const [log, setLog] = useState([]);
  const [data, setData] = useState([]);
  const [spin, setSpin] = useState(false);
  const [input, setInput] = useState(null);
  const [user, setUser] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [filter, setFilter] = useState(null);
  const [count, setCount] = useState(0);
  const { t } = useTranslation();
  const cols = [
    { key: "tableIndex", value: "#", con: true },
    {
      key: "userName",
      value: t("İstifadəçi"),
      con: true,
    },
    {
      key: "roleName",
      value: "Səlahiyyəti",
      con: true,
    },
    { key: "companyName", value: "Şirkətin adı", con: false },
    { key: "operationName", value: "Əməliyyatın adı", con: false },

    { key: "operationDate", value: "Əməliyyat tarixi", con: false },
  ];

  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "tableIndex",
    //   key: "1",
    //   width: "100px",
    // },
    {
      // title: 'İstifadəçi',
      title: <span style={{ marginLeft: 10 }}>İstifadəçi</span>,
      dataIndex: "userName",
      key: "3",
    },
    {
      title: "Səlahiyyəti",
      dataIndex: "roleName",
      key: "6",
      render: (roleName) => (
        <span
          style={{
            display: "inline-block",
            background: "#f5f5f5",
            border: "1px solid #c9c9c9",
            borderRadius: "6px",
            padding: "2px 6px",
            fontSize: "11px",
            lineHeight: "16px",
            color: "#595959",
          }}
        >
          {roleName}
        </span>
      ),
    },
    {
      title: 'Şirkətin adı',
      dataIndex: "companyName",
      key: "8",
      // ellipsis: true,
      width: "400px",
    },
    {
      title: "Əməliyyatın adı",
      dataIndex: "operationName",
      key: "9",
      render: (operation) => {
        let color = "#1677ff"; // primary blue
        let bg = "#e6f4ff";
        let border = "#91caff";

        if (operation === "Yaradıldı") {
          color = "#4cb915"; // success
          bg = "#f6ffed";
          border = "#b7eb8f";
        }
        else if (operation === "Redaktə edildi") {
          color = "#d8940c"; // warning (Ant Design correct tone)
          bg = "#fffbe6";
          border = "#ffe58f";
        }
        else if (operation === "Baxıldı") {
          color = "#0b65e4"; // info / primary
          bg = "#e6f4ff";
          border = "#91caff";
        }
        else {
          color = "#8c8c8c"; // default gray
          bg = "#f5f5f5";
          border = "#d9d9d9";
        }

        return (
          <Tag
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: "11px",
              padding: "0 8px",
              borderRadius: "999px",
              border: `1px solid ${border}`,
              backgroundColor: bg,
              color: color,
              lineHeight: "18px",
            }}
          >
            {/* DOT */}
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: color,
                display: "inline-block",
              }}
            />
            {operation}
          </Tag>
        );
      },
    },
    {
      title: 'Əməliyyat tarixi',
      dataIndex: "operationDate",
      key: "10",
      render: (text) => (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <CalendarOutlined style={{ color: "#8c8c8c", fontSize: "10px" }} />
          {moment(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    },
  ];

  const getLog = () => {
    setSpin(true);
    const params = {
      PerDataCount: (page - 1) * pageSize,
      GetDataCount: pageSize,
      UserName: filter?.UserName,
      RoleName: filter?.RoleName,
      OperationStartDate: filter?.OperationStartDate,
      OperationEndDate: filter?.OperationEndDate

    };

    aictia.get("OperationLog", { params }).then((res) => {
      res.data && setSpin(false);
      setLog(
        res.data.data.map((d, index) => {
          return {
            ...d,
            key: index + 1,
            index,
            tableIndex: index + 1 + (page - 1) * pageSize,
          };
        })
      );
      setCount(res.data.count)
    });
  };
  const onSearch = (values) => {
    const params = {
      ...values,
      OperationStartDate: values.OperationStartDate && values.OperationStartDate[0].format("YYYY-MM-DD"),
      OperationEndDate: values.OperationStartDate && values.OperationStartDate[1].format("YYYY-MM-DD"),
      PerDataCount: (page - 1) * pageSize,
      GetDataCount: pageSize,
    };
    setFilter(params);
    setSpin(true);
    aictia
      .get("OperationLog", { params })
      .then((res) => {
        setSpin(false);
        setLog(
          res.data.data.map((d, index) => {
            return {
              ...d,
              key: index + 1,
              index,
              tableIndex: res.data.count - index - (page - 1) * pageSize,
            };
          })
        );
        setCount(res.data.count)
      })
      .catch((err) => {
        setSpin(false);
        notify(err.response.data, false);
      });
  };
  const clearFilter = () => {
    form.resetFields();
    setInput(null);
    setFilter(null);
    getLog();
  };
  const getUser = () => {
    aictia.get("User").then((res) => {
      setUser(res.data);
    });
  };


  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    getLog();
  }, [page, pageSize, t]);



  return (
    <div>
      <Row gutter={[10, 10]} className="pl-1">
        <Col xs={24}>
          <div className="border flex animated fadeInDown p-2 mt-0 bg-white" style={{ borderRadius: '20px' }}>
            <span
              style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: "#eff6ff",
                color: "#0c82f4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 10,
                marginTop: 5,
              }}
            >
              <ContainerOutlined className="f-20" />
            </span>
            <div>
              <span className="f-20 bold">{t("logs")}</span>
              <p className="text-[11px] text-slate-450 font-medium">{t("logsSub")}</p>
            </div>
          </div>
        </Col>



        <Col xs={24}>
          <Form onFinish={onSearch} layout="vertical" form={form}>
            <div className="border commontask bg-white px-2 pt-15 pb-15" style={{ borderRadius: '20px' }}>
              <Row className={"mt-5"} gutter={[16, 8]}>
                <Col md={7} sm={13} xs={24}>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    <label
                      style={{
                        fontSize: "10px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        color: "black",
                      }}
                    >
                      Əməliyyat Tarixi (Aralıq)
                    </label>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                      <Form.Item
                        name="OperationStartDate"
                        style={{ marginBottom: 0 }}
                      >
                        <DatePicker
                          placeholder="Başlanğıc"
                          style={{
                            width: "100%",
                            height: 38,
                            borderRadius: 12,
                            background: "#f8fafc",
                            border: "1px solid #e2e8f0",
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        name="OperationEndDate"
                        style={{ marginBottom: 0 }}
                      >
                        <DatePicker
                          placeholder="Son tarix"
                          style={{
                            width: "100%",
                            height: 38,
                            borderRadius: 12,
                            background: "#f8fafc",
                            border: "1px solid #e2e8f0",
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </Col>
                <Col md={4} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label
                      style={{
                        fontSize: "10px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        color: "black",
                      }}
                    >
                      İstifadəçi
                    </label>

                    <Form.Item
                      name="UserName"
                      style={{ marginBottom: 0 }}
                    >
                      <Select
                        placeholder={t("İstifadəçi")}
                        style={{
                          width: "100%",
                        }}
                        className="custom-select2"
                        options={user.map((p) => ({
                          label: p.username,
                          value: p.username,
                        }))}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col md={4} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label
                      style={{
                        fontSize: "10px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        color: "black",
                      }}
                    >
                      Səlahiyyət
                    </label>

                    <Form.Item
                      name="RoleName"
                      style={{ marginBottom: 0, width: "100%" }}
                    >
                      <Select
                        className="custom-select2"
                        placeholder={t("Səlahiyyət")}
                      >
                        <option value="">Səlahiyyət seçin</option>
                        <option value="Admin">Admin</option>
                        <option value="Inspector">Inspector</option>
                        <option value="Organization">Organization</option>
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col md={4} sm={12} xs={24}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label
                      style={{
                        fontSize: "10px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        color: "black",
                      }}
                    >
                      Şirkətin adı / Mövzu
                    </label>
                    <Form.Item
                      name="CompanyName"
                      style={{ marginBottom: 0, width: "100%" }}
                    >
                      <Input
                        type="text"
                        placeholder={t("Şirkətin adı")}
                        style={{
                          width: "100%",
                          height: 38,
                          borderRadius: 12,
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col md={4} sm={24} xs={24}>
                  <div style={{ display: "flex", gap: "8px", width: "100%", marginTop: "21px" }}>
                    <Button
                      htmlType="submit"
                      type="primary"
                      style={{
                        flex: 1,
                        height: "38px",
                        borderRadius: "12px",
                        background: "#0c82f4",
                        border: "none",
                        fontSize: "12px",
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        boxShadow: "none",
                      }}
                    >
                      <SearchOutlined />
                      Axtar
                    </Button>

                    <Button
                      onClick={clearFilter}
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "12px",
                        background: "#ecfdf5",
                        border: "1px solid #bbf7d0",
                        color: "#059669",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "none",
                      }}
                    >
                      <ClearOutlined />
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        </Col>

        <>
          {spin ? (
            <Col xs={24}>
              <div className="flex animated fadeInUp bg-white all-center p-2">
                <Spin size={"large"} />
              </div>
            </Col>
          ) : (
            <Col xs={24} >
              <div
                className="border animated fadeInUp pt-5"
                style={{
                  borderRadius: 20,
                  overflow: "hidden",
                  background: "#fff",
                }}
              >
                <Table
                  size="small"
                  className="bg-white animated fadeIn"
                  columns={columns}
                  dataSource={convertColumns(log, cols)}
                  rowClassName={(record) => {
                    if (record.operationName === "Yaradıldı") return "row-created";
                    if (record.operationName === "Redaktə edildi") return "row-edited";
                    if (record.operationName === "Baxıldı") return "row-viewed";
                    return "";
                  }}
                  pagination={{
                    pageSize: pageSize,
                    current: page,
                    total: count,
                    locale: { items_per_page: "/ səhifələnmə" },

                    onChange: (page, pageSize) => {
                      setPage(page);
                      setPageSize(pageSize);

                    }
                  }}
                />
              </div>
            </Col>
          )}
        </>
      </Row>
    </div>
  );
}

export default connect(null, { notify })(Logs);
